import * as types from '../types/smProjectDetail';
import * as actions from '../actions/lsProjectDetail';

const INITIAL_SIDER_STATE = {
  showDrawerSider: false,
  loadingSider: false,
  siderData: undefined,
  siderSelectedKeys: undefined,
};

const LOADING_STATE = {
  loaded: false,
  loading: true,
  hasError: false,
};

const INITIAL_STATE: types.ProjectDetail = {
  detailLoading: false,
  detail: undefined,
  journals: { ...LOADING_STATE },
  ...INITIAL_SIDER_STATE,
};

export default function(
  state: types.ProjectDetail = INITIAL_STATE,
  action: actions.ProjectDetailActions,
): types.ProjectDetail {
  switch (action.type) {
    case actions.LOAD_DETAIL: {
      const { data = {} } = action;
      const { changedBySider = false } = data;
      const detail = state.detail
        ? { ...state.detail, has_sider: changedBySider }
        : undefined;
      const siderState = changedBySider ? {} : INITIAL_SIDER_STATE;
      return { ...state, detailLoading: true, detail, ...siderState };
    }
    case actions.LOAD_DETAIL_SUCCESS: {
      const { data = {} } = action;
      const { detail = {} } = data;
      const siderSelectedKeys = detail.has_sider ? [`${detail.id}`] : undefined;
      return { ...state, detailLoading: false, detail, siderSelectedKeys };
    }
    case actions.LOAD_DETAIL_FAILED: {
      return { ...state, detailLoading: false };
    }
    case actions.CLEAR_DETAIL: {
      return { ...INITIAL_STATE };
    }

    case actions.TOOGLE_DRAWER_SIDER_SHOW: {
      const { data = {} } = action;
      const { showDrawerSider = false } = data;
      return { ...state, showDrawerSider };
    }
    case actions.LOAD_SIDER: {
      return { ...state, loadingSider: true };
    }
    case actions.LOAD_SIDER_SUCCESS: {
      const { data = {} } = action;
      const { siderData, siderSelectedKeys } = data;
      return { ...state, loadingSider: false, siderData, siderSelectedKeys };
    }
    case actions.LOAD_SIDER_FAILED: {
      return { ...state, loadingSider: false };
    }
    case actions.LOADING: {
      const { fromType = 'journals' } = action;
      return { ...state, [fromType]: { ...state[fromType], loading: true } };
    }
    case actions.GET_ERROR: {
      const { fromType = 'journals' } = action;
      return {
        ...state,
        [fromType]: { ...state[fromType], loading: false, hasError: true },
      };
    }
    case actions.GET_JOURNALS_SUCCESS: {
      return {
        ...state,
        journals: { ...action.data, loaded: true, loading: false },
      };
    }
  }
  return state;
}
